module.exports = __webpack_public_path__ + "img/434-63ce24.png";